import script from "./EditableComment.vue?vue&type=script&setup=true&lang=js"
export * from "./EditableComment.vue?vue&type=script&setup=true&lang=js"

import "./EditableComment.vue?vue&type=style&index=0&id=1b8422f4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b8422f4"]])

export default __exports__